/** Toast notification styles — fixed stack near the FAB with slide-in/out animations. */
export const TOAST_CSS = `
    .pw-toast-container {
      position: fixed;
      bottom: 90px;
      right: 16px;
      display: flex;
      flex-direction: column-reverse;
      gap: 8px;
      z-index: 2147483646;
      pointer-events: none;
      max-width: 320px;
    }

    .pw-toast {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      padding: 10px 12px;
      border-radius: 10px;
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15),
                  0 0 0 1px rgba(0, 0, 0, 0.04);
      font: 400 13px/1.4 var(--pw-font);
      color: #1a1a1a;
      pointer-events: auto;
      animation: pw-toast-enter 0.28s cubic-bezier(0.34, 1.56, 0.64, 1) both;
      cursor: default;
      min-width: 220px;
    }

    .pw-toast-exit {
      animation: pw-toast-exit 0.24s ease-in forwards;
    }

    @keyframes pw-toast-enter {
      0% { opacity: 0; transform: translateX(40px) scale(0.92); }
      100% { opacity: 1; transform: translateX(0) scale(1); }
    }
    @keyframes pw-toast-exit {
      0% { opacity: 1; transform: translateX(0) scale(1); }
      100% { opacity: 0; transform: translateX(40px) scale(0.92); }
    }

    .pw-toast-error {
      background: rgba(254, 242, 242, 0.95);
      border-left: 3px solid #DC5555;
    }
    .pw-toast-error .pw-toast-icon { color: #DC5555; }

    .pw-toast-warn {
      background: rgba(255, 251, 235, 0.95);
      border-left: 3px solid #D97706;
    }
    .pw-toast-warn .pw-toast-icon { color: #D97706; }

    .pw-toast-info {
      background: rgba(239, 246, 255, 0.95);
      border-left: 3px solid #3B82F6;
    }
    .pw-toast-info .pw-toast-icon { color: #3B82F6; }

    .pw-toast-icon {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      margin-top: 1px;
    }
    .pw-toast-icon svg { display: block; }

    .pw-toast-msg {
      flex: 1;
      word-break: break-word;
    }

    .pw-toast-action {
      flex-shrink: 0;
      background: none;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 6px;
      padding: 3px 10px;
      font: 500 12px/1.3 var(--pw-font);
      color: #1a1a1a;
      cursor: pointer;
      white-space: nowrap;
      transition: background 0.15s ease;
    }
    .pw-toast-action:hover {
      background: rgba(0, 0, 0, 0.06);
    }

    .pw-toast-close {
      flex-shrink: 0;
      background: none;
      border: none;
      padding: 2px;
      cursor: pointer;
      color: rgba(0, 0, 0, 0.4);
      transition: color 0.15s ease;
      outline: none;
    }
    .pw-toast-close:hover { color: rgba(0, 0, 0, 0.7); }
    .pw-toast-close svg { display: block; }
`;
